export default __webpack_public_path__ + "static/media/57_4_1.edf4a564.png";